module.exports = __webpack_public_path__ + "static/media/41.7241adf1.jpg";